import { JobAlert } from '@models/profile/job-alert';

export class GetJobAlerts {
  static readonly type = '[JobAlerts] Get';

  constructor(readonly profileId: string, readonly force = false) {}
}

export class GetJobAlertsSuccess {
  static readonly type = '[JobAlerts] Get Success';

  constructor(readonly jobAlerts: JobAlert[]) {}
}

export class CreateJobAlert {
  static readonly type = '[JobAlert] Create';

  constructor(readonly profileId: string, readonly jobAlert: JobAlert) {}
}

export class CreateJobAlertSuccess {
  static readonly type = '[JobAlert] Create Success';

  constructor(readonly jobAlert: JobAlert) {}
}

export class PatchJobAlert {
  static readonly type = '[JobAlert] Patch';

  constructor(readonly profileId: string, readonly jobAlert: JobAlert) {}
}

export class PatchJobAlertSuccess {
  static readonly type = '[JobAlert] Patch Success';

  constructor(readonly jobAlert: JobAlert) {}
}

export class DeleteJobAlert {
  static readonly type = '[JobAlert] Delete';

  constructor(readonly profileId: string, readonly jobAlertId: string) {}
}

export class DeleteJobAlertSuccess {
  static readonly type = '[JobAlert] Delete Success';

  constructor(readonly jobAlertId: string) {}
}
